<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
  [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
  [token]="token">

  <ng-container *ngIf="consulta">

    <table class="table table-striped table-sm">
      <tr class="text-primary text-center">
        <th>Placa</th>
        <th>Chassi</th>
      </tr>
      <tr class="text-center">
        <td>{{consulta?.placa || 'NÃO INFORMADO'}}</td>
        <td>{{consulta?.chassi || 'NÃO INFORMADO'}}</td>
      </tr>
    </table>

  </ng-container>

</app-card-consulta>
